import { PrivacyPage } from "@/common/components/privacy/PrivacyPage";
import { PAGE_TITLE } from "@/common/constants/constants";
import Head from "next/head";

const Privacy = () => {
  return (
    <>
      <Head>
        <title>{PAGE_TITLE.PRIVACY}</title>
        <meta name="description" content="JozyJobs app" />
      </Head>
      <PrivacyPage />
    </>
  );
};
export default Privacy;
